var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "router-link",
    {
      class: _vm.buttonClasses,
      attrs: {
        to: _vm.to,
        replace: _vm.replace,
        "data-test": "router-link",
        dir: "auto",
      },
      nativeOn: {
        mouseenter: function ($event) {
          _vm.hovering = true
        },
        mouseleave: function ($event) {
          _vm.hovering = false
        },
      },
    },
    [
      _vm._t("icon", function () {
        return [
          _vm.icon
            ? _c("KIcon", {
                staticStyle: { top: "4px" },
                attrs: {
                  icon: _vm.icon,
                  color: _vm.iconColor,
                  "data-test": "icon-before",
                },
              })
            : _vm._e(),
        ]
      }),
      _vm.$slots.default
        ? _vm._t("default")
        : [
            _c("span", { staticClass: "link-text", style: _vm.spanStyle }, [
              _vm._v(_vm._s(_vm.text)),
            ]),
          ],
      _vm._t("iconAfter", function () {
        return [
          _vm.iconAfter
            ? _c("KIcon", {
                staticStyle: { top: "4px" },
                attrs: {
                  icon: _vm.iconAfter,
                  color: _vm.iconColor,
                  "data-test": "icon-after",
                },
              })
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }